import * as React from 'react';
import { CONSTANTS } from '../../assets/UIConstants';

interface Props {
    height?: number;
}

export class PanelFooter extends React.Component<Props, {}> {

    private style: React.CSSProperties = {
        container: {
            display: CONSTANTS.DISPLAY.FLEX,
            height: this.props.height || 90,
            justifyContent: CONSTANTS.FLEX_JUSTIFY.SPACE_BETWEEN,
            alignItems: CONSTANTS.ALIGN_ITEMS.CENTER,
            paddingLeft: 30, 
            paddingRight: 20,
        }
    };

    public render(): JSX.Element {
        return (
            <div style={this.style.container}>
                {this.props.children}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/PanelFooter.tsx